import React from 'react';
import BaseSection from 'commonComponents/sections/BaseSection/BaseSection';
import PrimarySectionHeader from 'commonComponents/Headers/PrimarySectionHeader/PrimarySectionHeader';
import styles from './HeadersWithContentAndImage.module.scss';

const classNames = require('classnames');

const HeadersWithContentAndImage = ({
  title,
  subtitle,
  anchor,
  image,
  additionalClass,
  textContent,
  additionalContent
}) => {
  const classes = classNames(
    styles.HeadersWithContentAndImage,
    styles[additionalClass]
  );

  return (
    <BaseSection additionalClass={ classes }>
      <div className={ styles.contentWithImage }>
        <article>
          <PrimarySectionHeader
            header={ title }
            subheader={ subtitle }
            anchor={ anchor }
            additionalClass={ styles.header }
          />
          { textContent }
        </article>
        <figure className={ styles.image }>
          <img src={ image } alt={ title } />
        </figure>
      </div>
      { additionalContent }
    </BaseSection>
  );
};

export default HeadersWithContentAndImage;
